
const CHUNK_RELOAD_KEY = "upsider_chunk_reload";

export function isChunkLoadError(err: unknown): boolean {
  if (!err) return false;
  const name = typeof err === "object" && "name" in err ? String((err as { name?: unknown }).name) : "";
  if (name === "ChunkLoadError") return true;
  const message =
    typeof err === "object" && "message" in err
      ? String((err as { message?: unknown }).message)
      : String(err);
  return (
    /Loading (?:CSS )?chunk [\w-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /error loading dynamically imported module/i.test(message)
  );
}

export function handleChunkLoadError(
  err: unknown,
  storage: Pick<Storage, "getItem" | "setItem">,
  reload: () => void,
): boolean {
  if (!isChunkLoadError(err)) return false;
  try {
    if (storage.getItem(CHUNK_RELOAD_KEY) === "1") return false;
    storage.setItem(CHUNK_RELOAD_KEY, "1");
  } catch {
    return false;
  }
  reload();
  return true;
}

export function installChunkReloadHandler(): void {
  if (typeof window === "undefined") return;
  const onError = (event: ErrorEvent) => {
    handleChunkLoadError(event.error, window.sessionStorage, () => window.location.reload());
  };
  const onRejection = (event: PromiseRejectionEvent) => {
    handleChunkLoadError(event.reason, window.sessionStorage, () => window.location.reload());
  };
  window.addEventListener("error", onError);
  window.addEventListener("unhandledrejection", onRejection);
}
